<link href="http://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/materialize/0.97.8/css/materialize.min.css">
<div
  style="background: url(../../images_ext/login-bg1.jpg);background-size: cover;line-height: 1.5;font-family: 'Roboto', sans-serif;font-weight: normal;color: rgba(0,0,0,0.87);height: 100%;position: absolute;width: 100%;">

  <div class="" [class.hidden]="preLoader"
    style="width: 100%;text-align: center;height: 100%;position: fixed;padding-top: 45vh;">
    <img *ngIf="brand.id" class="animated infinite pulse" [src]="brand.logoPath" style="width: 125px;">
  </div>

  <div class="container">
    <div class="row" style="margin: 0;">
      <!-- for normal schools -->
      <div *ngIf="isFranchise == 0 && fkFranchiseId == null" class="col m12 center-align">
        <img src="images_ext/bw_logo.png" style="width: 250px;margin-top: 2vh;margin-bottom: 2vh;">
      </div>

      <!-- for franchise -->
      <div *ngIf="isFranchise == 1 || isFranchise == 0 && fkFranchiseId != null" class="col m12 center-align">
        <img src="images_ext/login_screen_logo.png" style="width: 250px;margin-top: 2vh;margin-bottom: 2vh;">
      </div>

      <div class="col s12 card center-align">

        <!-- for normal schools -->
        <div *ngIf="isFranchise == 0 && fkFranchiseId == null" class="col m6" style="padding: 25px 25px;">
          <h5 style="margin-top: 5vh;color: #8a8a8a;font-weight: 300;font-size: 1.4rem;">Welcome to {{ brand.name }}</h5>
          <img src="{{loginSchoolLogo}}" class="img-responsive" style="margin: 0 auto;width: 150px;">
          <h5 style="color: grey;    margin-bottom: 0;text-transform: capitalize;">{{loginSchoolName}}</h5>
          <p style=" margin: 0; color: grey;text-transform: capitalize;">{{loginSchoolState}}</p>
        </div>

        <!-- for franchise  -->
        <div *ngIf="isFranchise == 1 || isFranchise == 0 && fkFranchiseId != null" class="col m6" style="padding: 25px 25px;">
          <h5 style="margin-top: 5vh;color: #8a8a8a;font-weight: 300;font-size: 1.4rem;">Welcome</h5>
          <img src="{{loginSchoolLogo}}" class="img-responsive" style="margin: 0 auto;width: 150px;">
          <h5 style="color: grey;    margin-bottom: 0;text-transform: capitalize;">{{loginSchoolName}}</h5>
          <p style=" margin: 0; color: grey;text-transform: capitalize;">{{loginSchoolState}}</p>
        </div>


        <div class="col m6" style="border-left: 1px solid #e6e6e6;">

          <div class="col-md-12 loader" [class.hidden]="!loaderLogin"
            style="position: absolute;left: 0;right: 0;background: rgba(255, 255, 255, 0.64);z-index: 999;height: 100%;padding: 15em 0em;text-align: center;">
            <img src="https://www.criminalwatchdog.com/images/assets/loading.gif" class="img-responsive"
              style="margin: 0 auto;width: 75px;">
          </div>

          <!-- for normal schools -->
          <div *ngIf="isFranchise == 0 && fkFranchiseId == null" class="first-half">
            <img class="responsive-img" src="images_ext/first-half.jpg">
          </div>
          <!-- for franchise -->
          <div *ngIf="isFranchise == 1 || isFranchise == 0 && fkFranchiseId != null" class="first-half">
            <img class="responsive-img" src="images_ext/first-half-2.jpg">
          </div>

          <div class="" style="text-align: center;">
            <table>
              <td style="padding: unset;">
                <hr>
              </td>
              <td style="    width: 100px;text-align: center;padding: unset;">
                <span *ngIf="loginMode == 'STAFF'" style="border: none;bottom:0;color: black">Staff
                  Login</span>
                <span *ngIf="loginMode == 'WEB_ADMIN'" style="border: none;bottom:0;color: black">Admin
                  Login</span>
              </td>
              <td style="padding: unset;">
                <hr>
              </td>
            </table>
          </div>
          <div class="second-half">
            <form class="col s12" style="padding: 0px 50px;">
              <div class="">
                <div class="input-field">
                  <input [(ngModel)]="username" [ngModelOptions]="{standalone: true}"
                    placeholder="Enter user name for admin login" id="user_name" type="text">
                  <!--<label for="user_name">User name</label>-->
                  <span *ngIf="errorMessage.username" style="font-size: 14px;color: #F44336;display: flex;
                  position: absolute; top: 52px;">{{errorMessage.username}}</span>
                  <!-- <span id = "user_name" *ngIf="errorMessage.username" style="color: #F44336; position: fixed;">{{errorMessage.username }}</span> -->
                </div>
                <div class="input-field">
                  <input [(ngModel)]="password" [ngModelOptions]="{standalone: true}" placeholder="Your Password"
                    id="user_password" type="password">
                    <!-- <span id = "user_password" *ngIf="errorMessage.password" style="color: #F44336; position: fixed;">{{errorMessage.password }}</span> -->
                    <span *ngIf="errorMessage.password" style="font-size: 14px;color: #F44336;display: flex;top: 52px;
                    position: absolute;">{{errorMessage.password}}</span>
                  <!-- <label for="user_name">Password</label> -->
                </div>
              </div>
              <span *ngIf="loginError" style="font-size: 14px;color: red">Incorrect username or
                password</span>
            </form>
            <div class="col m12 right-align" style="padding: 20px 50px; margin-bottom: 30px;">
              <!--<a [routerLink]="['/dashboard']" class="waves-effect waves-light btn login-btn" style="width: 100%;background: #0686cd;">Login</a>-->
              <a (click)="loginAuth()" class="waves-effect waves-light btn login-btn"
                style="width: 100%;background: #0686cd;">Login</a>

              <div *ngIf="isFranchise == 0" style="text-align: center">
                <br>
                <a *ngIf="loginMode == 'STAFF'" (click)="switchToAdminLogin()"
                  style="border: none;bottom:0;cursor: pointer;color: #039be5;"><i class="fa fa-arrow-left" aria-hidden="true"></i>
                  Switch to Admin login?</a>
                <a *ngIf="loginMode == 'WEB_ADMIN'" (click)="switchToStaffLogin()"
                  style="border: none;bottom:0;cursor: pointer;color: #039be5;">Switch to Staff login? <i class="fa fa-arrow-right"
                    aria-hidden="true"></i></a>
              </div>
            </div>

          </div>
        </div>
        <div class="col m6 offset-m3">
          <div class="col m12 center-align">
            <p style="color: #d8d8d8;font-size: 12px;">&copy; {{currentYear}} {{ brand.name }} All right reserved
            </p>
          </div>
          <!--  <div class="col m6 right-align">
         <p style="color: #d8d8d8;font-size: 12px;">All right reserved</p>
       </div> -->
        </div>
      </div>
    </div>
  </div>

  <!--Import jQuery before materialize.js-->
  <script type="text/javascript" src="https://code.jquery.com/jquery-2.1.1.min.js"></script>
  <!-- Compiled and minified JavaScript -->
  <script src="https://cdnjs.cloudflare.com/ajax/libs/materialize/0.97.8/js/materialize.min.js"></script>
</div>